import "./profileCom.css"
import { AiOutlineUser } from "react-icons/ai";
import { FaCartShopping } from "react-icons/fa6";
import { FaIdBadge } from "react-icons/fa6";
import { FaPenToSquare } from "react-icons/fa6";
import { FaArrowRightToBracket } from "react-icons/fa6";
import { Outlet } from "react-router-dom";
import useSignOut from 'react-auth-kit/hooks/useSignOut';
import { useNavigate } from "react-router-dom";

function ProfileCom() {
    const navigate = useNavigate()
    const signOut = useSignOut()
    return (
        <div className="profilecom">
            <div className="profilecom-container">
                <div className="right-rpofilecom">
                    <ul>
                        <li onClick={() => navigate("/profile")}>
                            <AiOutlineUser />
                            حساب کاربری
                        </li>
                        <li onClick={() => navigate("/profile/orders")}>
                            <FaCartShopping />
                            سفارشات
                        </li>
                        <li onClick={() => navigate("/profile/address")}>
                            <FaIdBadge />
                            آدرس ها
                        </li>
                        <li onClick={() => navigate("/profile/editUserInfo")}>
                            <FaPenToSquare />
                            ویرایش اطلاعات
                        </li>
                        <li onClick={() => signOut()}>
                            <FaArrowRightToBracket />
                            خروج
                        </li>
                    </ul>
                </div>
                <div className="left-lpofilecom">
                    <Outlet />
                </div>
            </div>
        </div>
    )
}
export default ProfileCom;